import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { useDispatch } from "react-redux";
import { set_active_tab } from "../../Redux/Tab/Tab.action";
import { Markup } from "interweave";

import Header from "../Header/Header";
import "./applyNowRfqs.css";
import {
  TextInput,
  FilePicker,
  Textarea,
  Checkbox,
  Button,
} from "evergreen-ui";
import { useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ModalTandC } from "./ModalTandC";
import SubmitButton from "../Buttons/SubmitButton/SubmitButton";
import { PRODUCT } from "../../Utils/variables";
const ApplyNowRFQs = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [submitLoading, setsubmitLoading] = useState(false);

  // ---------------states for t and c----------------------
  const [grandTotal, setgrandTotal] = useState(0);
  const [remark, setremark] = useState();
  const [multiTandC, setmultiTandC] = useState([]);
  const [modalData, setmodalData] = useState({ title: "", desc: "" });
  const [tandcInputValues, settandcInputValues] = useState([
    { id: 0, term: "" },
    { id: 1, term: "" },
    { id: 2, term: "" },
    { id: 3, term: "" },
    { id: 4, term: "" },
  ]);

  // ---------------states for modal----------------------
  const [disablebtn, setDisableBtn] = useState(false);
  const [open, setOpen] = useState(false);
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);
  const handleDisablebtn = () => setDisableBtn(true);

  const [disablebtn2, setDisableBtn2] = useState(false);
  const [open2, setOpen2] = useState(false);
  const onOpenModal2 = () => setOpen2(true);
  const onCloseModal2 = () => setOpen2(false);
  const handleDisablebtn2 = () => setDisableBtn2(true);
  // ---------------states for files----------------------

  const [allFiles, setallFiles] = useState([
    // { unique: "trade_license" },
    // { unique: "quote_document" },
    // { unique: "other_document" },
    // { unique: "tax_reg" },
  ]);
  const [basicClose, setbasicClose] = useState({
    card1: true,
    card2: true,
    card3: true,
    card4: true,
    card5: true,
    card10: true,
    card11: true,
    card12: true,
    card13: true,
    card14: true,
    card15: true,
  });
  const [vendorId, setvendorId] = useState();
  const [notes, setnotes] = useState();
  const [tandc1, settandc1] = useState("");
  const [tandc2, settandc2] = useState("");
  const [tandcagree1, settandcagree1] = useState(true);
  const [tandcagree2, settandcagree2] = useState(false);

  //  ----------------table input value-------------------------
  const [manipulatedTableLIst, setmanipulatedTableLIst] = useState();
  const [allData, setallData] = useState();
  const [getRfqId, setgetRfqId] = useState();

  const TandCFunction = () => {
    return (
      <>
        {multiTandC &&
          multiTandC.map((e, i) => {
            return (
              <>
                <Markup className="marginTandCinRrqtitle" content={e.title} />

                <Markup className="marginTandCinRrqdesc" content={e.desc} />
              </>
            );
          })}
      </>
    );
  };

  const AllRfqData = (rfq_id) => {
    fetch(process.env.REACT_APP_API_URL + "/api/vendorRfq/rfqById", {
      method: "POST",
      body: JSON.stringify({
        community_id: "312",
        rfq_id: rfq_id,
      }),
      headers: { "content-type": "application/json" },
    })
      .then((d) => d.json())
      .then((res) => {
        setallData(res.response[0]);
        const narr = res.response[0].tc;
        setmultiTandC(narr);

        let itemData = res.response[0].items;
        let manupulatedItemData = [];
        for (let x of itemData) {
          let obj = {};
          obj.rfq_item = x.item;
          obj.uom_name = x.uom_name;
          obj.uom = x.uom;
          obj.quantity = x.quantity;
          obj.amount = null;
          obj.vat = null;
          obj.total_amnt = null;
          obj.rfq_item_id = x.rfq_item_id;
          obj.aprox_amount = x.aprox_amount;
          obj.category_id = x.category_id;
          manupulatedItemData.push(obj);
        }
        setmanipulatedTableLIst(manupulatedItemData);
      })
      .catch((err) => console.log("e", err));
  };

  const submitAllRfq = () => {
    setsubmitLoading(true);
    // const remark = [];

    // for (let x = 0; x < multiTandC.length; x++) {
    //   remark.push(tandcInputValues[x].term);
    // }

    let charray = true;
    let arr =
      manipulatedTableLIst &&
      manipulatedTableLIst.map((e) => {
        return e.amount;
      });
    if (manipulatedTableLIst) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i] == null) {
          charray = false;
        }
      }
    }
    if (charray == false) {
      toast(`${"please fill amount"}`, {
        type: "error",
      });
      // } else if (tandc1.length < 1) {
      //   toast(`${"please fill term and condition"}`, {
      //     type: "error",
      //   });
      setsubmitLoading(false);
    } else {
      fetch(process.env.REACT_APP_API_URL + "/api/vendorRfq/store_quotation", {
        method: "POST",
        body: JSON.stringify({
          rfq_id: allData.rfq_id,
          notes: notes,
          is_agree_tc_one: "",
          term_condition_one: remark ? [remark] : [],
          is_agree_tc_two: "",
          term_condition_two: "",
          community_id: allData.community_id,
          vendor_id: vendorId,
          rfq_items: manipulatedTableLIst,
          created_by: vendorId,
          documents: allFiles,
        }),
        headers: { "content-type": "application/json" },
      })
        .then((d) => d.json())
        .then((res) => {
          if (res.status == false) {
            setsubmitLoading(false);
          }
          const typeOferror = res.status == false ? "error" : "success";
          toast(`${res.message}`, {
            type: typeOferror,
          });

          dispatch(set_active_tab(3));

          setTimeout(() => {
            navigate("/submittedqoutes");
          }, 2000);
        });
    }
  };

  // const handleTandCinput = (e, i) => {
  //   let newArr = [...tandcInputValues];
  //   newArr[i].term = e.target.value;
  //   settandcInputValues(newArr);
  // };

  const handleUpload = (event, unique) => {
    const formData = new FormData();
    formData.append("file", event[0]);
    // formData.append("documnet_root", allData.document_root);
    // formData.append("fileStatus", "1");

    fetch(process.env.REACT_APP_API_URL + "/api/FileUpload", {
      method: "POST",
      body: formData,
    })
      .then((d) => d.json())
      .then((res) => {
        const narr = [...allFiles].filter((e) => e.unique != unique);
        narr.push({
          unique,
          path: res.path,
          url: res.url,
          name: res.name,
          file_size: res.size,
          file_type: res.type,
        });

        setallFiles(narr);
      });
  };

  useEffect(() => {
    setgetRfqId(JSON.parse(localStorage.getItem("rfq_id")));
    AllRfqData(JSON.parse(localStorage.getItem("rfq_id")));

    setvendorId(JSON.parse(localStorage.getItem("vendorId")));
    document.title = PRODUCT + " - Quotation";
  }, []);

  // useEffect(() => {
  //   const sum =
  //     manipulatedTableLIst &&
  //     manipulatedTableLIst.reduce((accumulator, object) => {
  //       return accumulator + +object.total_amnt;
  //     }, 0);
  //   console.log("-------", sum);
  // }, [manipulatedTableLIst]);

  return (
    <div className="applynowMainPageDiv">
      <Header title={"Quotation"} />
      <div>
        <div className="rfqRightDivHead">
          <div>
            <div className="rfqRightDivHeadHeading">
              {allData && allData.rfq_title}
            </div>
            <div className="rfqRightDivHeadSubHeading">
              {allData && allData.name}
            </div>
          </div>
          <div>
            {/* <button
              className="applyNowbtnRfq"
              onClick={() => {
                submitAllRfq();
              }}
            >
              Submit Quote
            </button> */}
            {/* <Button
              className="submitQuoteBtn"
              isLoading={submitLoading}
              onClick={() => {
                submitAllRfq();
              }}
              size="medium"
            >
              Submit Quote
            </Button> */}
            <SubmitButton
              ApplyFunction={submitAllRfq}
              loading={submitLoading}
              text={"Submit Quote"}
            />
          </div>
        </div>
      </div>
      <div className="rfqRightDivData" id="applynowTableHeight">
        {/* -----------basic info----------------- */}
        <div>
          <div className="basicDetailsDivRfq">
            <div>
              <img src="./images/stratum/basicInfo.svg" alt="" />
              <span className="rfqsrightdivSubName">General Info</span>
            </div>
            <div
              className="basicDetailsDivRfqLogoDrop"
              onClick={() => {
                setbasicClose({ ...basicClose, card1: !basicClose.card1 });
              }}
            >
              <img
                src="./images/stratum/dropUpLogo.svg"
                className={!basicClose.card1 && "rotateSvg"}
                alt=""
              />
            </div>
          </div>
          {basicClose.card1 && (
            <div className="basicDetailsDivRfqColumDiv">
              <div>
                <p>RFQ NO</p>
                <div>{allData && allData.rfq_no}</div>

                {/* <p>PR NO</p>
                        <div>
                          {allData && allData.pr_display_number
                            ? allData.pr_display_number
                            : "NA"}
                        </div> */}

                {/* <p>CLOSING ON</p>
                <div>
                  {allData &&
                    moment(allData.closing_date).format("DD MMM YYYY")}
                </div> */}
              </div>

              <div>
                <p>POSTED ON</p>
                <div>
                  {allData && moment(allData.created_on).format("DD MMM YYYY")}
                </div>
                {/* <p>Expected Completion/Delivery</p>
                <div>
                  {allData &&
                    moment(allData.expected_delivery_completion_date).format(
                      "DD MMM YYYY"
                    )}
                </div> */}
              </div>
              <div>
                <p>CLOSING ON</p>
                <div>
                  {allData &&
                    moment(allData.closing_date).format("DD MMM YYYY")}
                </div>
                {/* <p>Expected Completion/Delivery</p>
                <div>
                  {allData &&
                    moment(allData.expected_delivery_completion_date).format(
                      "DD MMM YYYY"
                    )}
                </div> */}
              </div>
              <div>
                <p>Expected Completion/Delivery</p>
                <div>
                  {allData &&
                    moment(allData.expected_delivery_completion_date).format(
                      "DD MMM YYYY"
                    )}{" "}
                </div>
                {/* <p>Expected Completion/Delivery</p>
                <div>
                  {allData &&
                    moment(allData.expected_delivery_completion_date).format(
                      "DD MMM YYYY"
                    )}
                </div> */}
              </div>
              <div>
                {/* <p>MANAGED BY</p>
                        <div>{allData && allData.rfq_no}</div> */}
              </div>
            </div>
          )}
        </div>

        {/* -----------ITEMS---------------- */}
        <div>
          <div className="basicDetailsDivRfq">
            <div>
              <img src="./images/stratum/item.svg" alt="" />
              <span className="rfqsrightdivSubName">Items</span>
            </div>
            <div
              className="basicDetailsDivRfqLogoDrop"
              onClick={() => {
                setbasicClose({ ...basicClose, card2: !basicClose.card2 });
              }}
            >
              {" "}
              <img
                src="./images/stratum/dropUpLogo.svg"
                className={!basicClose.card2 && "rotateSvg"}
                alt=""
              />
            </div>
          </div>
          {basicClose.card2 && (
            <div
              className="basicDetailsDivRfqColumDiv"
              id="basicDetailsDivRfqColumDivimp"
            >
              <table className="rfqtable">
                <tr className="rfqtableHead">
                  <th id="itemMarginLeft">DESCRIPTION</th>
                  <th>UOM</th>
                  <th>QTY</th>
                  <th>PRICE PER UNIT</th>
                  <th>VAT (%)</th>
                  <th className="totalColPaddingRight">TOTAL AMOUNT</th>
                </tr>
                {manipulatedTableLIst &&
                  manipulatedTableLIst.map((elem, i) => {
                    return (
                      <tr className="rfqtablData addMarginBottom">
                        <td className="itemMarginLeftData">{elem.rfq_item}</td>
                        <td>{elem.uom_name}</td>
                        <td>{elem.quantity}</td>
                        <td className="setColWidth">
                          <TextInput
                            className="numberInput"
                            type="number"
                            required
                            // className="mgbottominput"
                            width={110}
                            height={32}
                            name="amount"
                            id={elem.rfq_item_id}
                            placeholder=""
                            value={elem.amount}
                            onChange={(ev) => {
                              // inputHandler(elem, i);
                              const newFeature = manipulatedTableLIst.map(
                                (f) => {
                                  if (f.rfq_item_id == ev.target.id) {
                                    f.amount = +ev.target.value;
                                    f.total_amnt =
                                      f.quantity * f.amount +
                                      (f.vat * (f.amount * f.quantity)) / 100;
                                  }
                                  return f;
                                }
                              );
                              setmanipulatedTableLIst(newFeature);
                              const sum = newFeature.reduce(
                                (accumulator, object) => {
                                  return accumulator + +object.total_amnt;
                                },
                                0
                              );
                              setgrandTotal(sum);
                            }}
                          />
                          {/* {e.quantity*e.amount+(((e.amount*e.quantity)*e.tax)/100)} */}
                        </td>
                        <td className="setColWidth">
                          <TextInput
                            className="numberInput"
                            type="number"
                            // className="mgbottominput"
                            width={110}
                            height={32}
                            name="vat"
                            id={elem.rfq_item_id}
                            placeholder=""
                            value={elem.vat}
                            onChange={(ev) => {
                              if (ev.target.value <= 100) {
                                // inputHandler(elem, i);
                                const newFeature = manipulatedTableLIst.map(
                                  (f) => {
                                    if (f.rfq_item_id == ev.target.id) {
                                      f.vat = +ev.target.value;
                                      f.total_amnt =
                                        f.quantity * f.amount +
                                        (f.vat * (f.amount * f.quantity)) / 100;
                                    }
                                    return f;
                                  }
                                );
                                setmanipulatedTableLIst(newFeature);
                                const sum = newFeature.reduce(
                                  (accumulator, object) => {
                                    return accumulator + +object.total_amnt;
                                  },
                                  0
                                );
                                setgrandTotal(sum);
                              }
                            }}
                          />{" "}
                        </td>
                        <td className="setColWidth">
                          <TextInput
                            className="numberInput"
                            // className="mgbottominput"
                            disabled
                            width={110}
                            height={32}
                            name="total_amnt"
                            id={elem.rfq_item_id}
                            placeholder=""
                            value={elem.total_amnt?.toFixed(2)}
                            onChange={(ev) => {
                              // inputHandler(elem, i);
                              const newFeature = manipulatedTableLIst.map(
                                (f) => {
                                  if (f.rfq_item_id == ev.target.id) {
                                    f.total_amnt = +ev.target.value;
                                  }
                                  return f;
                                }
                              );
                              setmanipulatedTableLIst(newFeature);
                              const sum = newFeature.reduce(
                                (accumulator, object) => {
                                  return accumulator + +object.total_amnt;
                                },
                                0
                              );
                              setgrandTotal(sum);
                            }}
                          />{" "}
                        </td>
                      </tr>
                    );
                  })}
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td className="grandTotalInApplyNow">Grand Total</td>
                  <td className="grandTotalInApplyNowValue">
                    {grandTotal.toFixed(2)}
                  </td>
                </tr>
              </table>
            </div>
          )}
        </div>

        {/* -----------Notes----------------- */}

        <div>
          <div className="basicDetailsDivRfq">
            <div>
              <img src="./images/stratum/notes.svg" alt="" />
              <span className="rfqsrightdivSubName">Notes</span>
            </div>
            <div
              className="basicDetailsDivRfqLogoDrop"
              onClick={() => {
                setbasicClose({ ...basicClose, card3: !basicClose.card3 });
              }}
            >
              {" "}
              <img
                src="./images/stratum/dropUpLogo.svg"
                className={!basicClose.card3 && "rotateSvg"}
                alt=""
              />
            </div>
          </div>
          {basicClose.card3 && (
            <div className="basicDetailsDivRfqColumDiv" id="columnImpRfq">
              <div>
                <p></p>

                <div>
                  {" "}
                  <Textarea
                    name="textarea-1"
                    placeholder="Notes..."
                    // width={351}
                    width="170%"
                    height={32}
                    value={notes}
                    onChange={(e) => {
                      setnotes(e.target.value);
                    }}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
        {/* -----------Attachments----------------- */}
        <div>
          <div className="basicDetailsDivRfq">
            <div>
              <img src="./images/stratum/attachment.svg" alt="" />
              <span className="rfqsrightdivSubName">Attachments</span>
            </div>
            <div
              className="basicDetailsDivRfqLogoDrop"
              onClick={() => {
                setbasicClose({ ...basicClose, card4: !basicClose.card4 });
              }}
            >
              {" "}
              <img
                src="./images/stratum/dropUpLogo.svg"
                className={!basicClose.card4 && "rotateSvg"}
                alt=""
              />
            </div>
          </div>
          {basicClose.card4 && (
            <div className="basicDetailsDivRfqColumDiv" id="columnImpRfq">
              <div>
                {/* <p>QOUTE DOCUMENT </p>
                <div>
                  {" "}
                  <FilePicker
                    multiple
                    width={351}
                    height={32}
                    placeholder="Browse..."
                    onChange={(e) => handleUpload(e, "quote_document")}
                    required
                  />
                </div> */}
                <p>ATTACHMENT - 1</p>
                <div>
                  <FilePicker
                    multiple
                    width={351}
                    height={32}
                    placeholder="Browse..."
                    onChange={(e) => handleUpload(e, "other_document")}
                    required
                  />
                </div>
              </div>
              <div>
                <p>ATTACHMENT - 2</p>
                <div>
                  <FilePicker
                    multiple
                    width={351}
                    height={32}
                    placeholder="Browse..."
                    onChange={(e) => handleUpload(e, "tax_reg")}
                    required
                  />
                </div>
                {/* <p>TRADE LICENSE</p>
                <div>
                  <FilePicker
                    multiple
                    width={351}
                    height={32}
                    placeholder="Browse..."
                    onChange={(e) => handleUpload(e, "trade_license")}
                    required
                  />
                </div> */}
              </div>
            </div>
          )}
        </div>
        {/* -----------Terms & Conditions --------------- */}

        <div>
          <div className="basicDetailsDivRfq">
            <div>
              <img src="./images/stratum/tandc.svg" alt="" />
              <span className="rfqsrightdivSubName">Terms & Conditions</span>
            </div>
            <div
              className="basicDetailsDivRfqLogoDrop"
              onClick={() => {
                setbasicClose({ ...basicClose, card5: !basicClose.card5 });
              }}
            >
              {" "}
              <img
                src="./images/stratum/dropUpLogo.svg"
                className={!basicClose.card5 && "rotateSvg"}
                alt=""
              />
            </div>
          </div>
          {basicClose.card5 && (
            <div className="basicDetailsDivRfqColumDiv" id="columnImpRfq">
              {/* {multiTandC &&
                multiTandC.map((e, i) => {
                  return ( */}
              <div>
                <p className="manageCheckboxApply">
                  <Checkbox
                    disabled
                    checked={tandcagree1}
                    onChange={(e) => {
                      settandcagree1(e.target.checked);
                    }}
                  />
                  I agree to accept
                  <span
                    className="tacapply"
                    onClick={() => {
                      // setmodalData({
                      //   title: e.title,
                      //   desc: e.desc,
                      // });
                      onOpenModal();
                    }}
                  >
                    Terms & Conditions
                    <span className="mandatoryStar">*</span>
                  </span>
                </p>
                <div>
                  {" "}
                  <Textarea
                    required
                    name="textarea-1"
                    placeholder="Notes..."
                    width="170%"
                    height={32}
                    value={remark}
                    onChange={(e) => {
                      // handleTandCinput(j, i);
                      setremark(e.target.value);
                    }}
                  />
                </div>
              </div>
              {/* ); */}
              {/* })} */}
            </div>
          )}
        </div>
      </div>
      <ToastContainer autoClose={5000} />
      <ModalTandC
        // title={modalData && modalData.title}
        // text={modalData && modalData.desc}
        data={multiTandC && multiTandC}
        open={open}
        onOpenModal={onOpenModal}
        onCloseModal={onCloseModal}
        handleDisablebtn={handleDisablebtn}
      />
      {/* <ModalTandC
        title={allData?.tnc_title}
        text={allData?.terms_condition}
        open={open2}
        onOpenModal={onOpenModal2}
        onCloseModal={onCloseModal2}
        handleDisablebtn={handleDisablebtn2}
      /> */}
    </div>
  );
};

export default ApplyNowRFQs;
